module.exports = __webpack_public_path__ + "img/feature_buy_ph.1d928294.png";